import React, {useEffect} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {zodResolver} from '@hookform/resolvers/zod'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useGetSettingsQuery, useSetSettingsMutation} from 'store/Store'
import {generalSettings, generalSettingsValidation} from 'constants/FormField/settings'
import {onSubmit} from 'services/utils/toastUtils'
import FormSection from 'components/Control/Form/FormSection'
import Button from 'components/Control/Button'
import Loader from 'components/Display/Loader/Loader'

const GeneralSettings = () => {
    const {t} = useTranslation()
    const {data: settings, isLoading} = useGetSettingsQuery()
    const [doSetSettings] = useSetSettingsMutation()

    const methods = useForm({
        resolver: zodResolver(generalSettingsValidation),
        defaultValues: settings,
    })
    const {reset, handleSubmit} = methods

    useEffect(() => {
        if (settings) reset(settings)
    }, [settings, reset])

    const submitEdit = handleSubmit((itemData) =>
        onSubmit({itemData, itemName: 'setting', doSomething: doSetSettings, commandType: 'edit', t})
    )

    if (isLoading) return <Loader show={true} />

    return (
        <FormProvider {...methods}>
            <FormSection
                fields={generalSettings}
                methods={methods}
                i18nCategory="settings.generalSettings"
            />
            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button variant="contained" onClick={submitEdit}>
                    {t('save')}
                </Button>
            </Box>
        </FormProvider>
    )
}

export default GeneralSettings
